export const DEFAULT_PAYMENT_LINKS = {
  niveau1: 'https://buy.stripe.com/bJe6oI0Ec8Fv0ud8tUgA801',
  niveau2: 'https://buy.stripe.com/5kQ3cw3Qof3T1yh4dEgA80h',
  niveau3: 'https://buy.stripe.com/dRm8wQ72AaND1yh25wgA80i',
  niveau4: 'https://buy.stripe.com/4gMbJ2biQaNDccV25wgA80j',
  niveau5: 'https://buy.stripe.com/28EcN60Ecf3T4KtdOegA80k',
  niveau6: 'https://buy.stripe.com/dRmcN6ev25tj7WF7pQgA80l',
};